// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"574":"b5c244a2","9765":"95dbecb4"}[chunkId] + ".chunk.css";
};